import { AtomKey } from '../_constants';
import { UserSubscribeType } from '@src/lib/user/types';
import { atom } from 'recoil';

export const UserSubscribeState = atom<UserSubscribeType | null>({
  key: AtomKey.USER_SUBSCRIBED,
  default: null,
});
